import React from 'react'
import ExpertCallout from '#src/components/ExpertCallout'
import styles from './styles.css'

interface ExpertCalloutProps {
  categorySlug: string
  categoryId: string
}

const DepartmentExpertCallout: React.SFC<ExpertCalloutProps> = ({ categorySlug, categoryId }) => {
  return (
    <div className={styles.wrapper}>
      <ExpertCallout placement="department" categorySlug={categorySlug} categoryId={categoryId} />
    </div>
  )
}

export default DepartmentExpertCallout
